import React from "react";
import {TextField} from "@material-ui/core";
import  './../PrePayment.scss'
import {PrePaymentFeeTooltipCreditCard} from "../tooltip/PrePaymentFeeTooltipCreditCard";

interface Props {
    fee: string
}

export class PrePaymentFeeCreditCard extends React.Component<Props> {

    render() {
        return <div className="field">
            <TextField label={'Fee:'}
                       value={this.props.fee}
                       disabled={true}
                       fullWidth={true}
                       InputProps={{
                           endAdornment: <PrePaymentFeeTooltipCreditCard/>
                       }}
            />
        </div>;
    }
}